import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import User from '../../singletons/User';
import { LOG } from '../../constants/routing';
import { Field, Formik } from 'formik';
import LoginSchema from '../../schemas/LoginSchema';
import { TextField } from 'formik-material-ui';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Grid } from '@material-ui/core';

const initialValues = Object.freeze({
  email: '',
  password: '',
});

const Login = props => {
  const history = useHistory();
  const classes = useStyles();

  const handleSubmit = useCallback(async (values, form) => {
    await User.login(values.email, values.password)
    history.push(LOG);
  }, []);

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={initialValues}
      validationSchema={LoginSchema}>
      {
        renderProps => {
          const { handleSubmit, values, isValid } = renderProps;
          return (
            <div className={classes.container}>
              <div className={classes.card}>
                <form className={classes.form} onSubmit={handleSubmit}>
                  <Grid container spacing={3} justifyContent={'center'}>
                    <Grid item xs={12}>
                      <Field
                        fullWidth
                        variant={'outlined'}
                        label={'Email'}
                        value={values.email}
                        component={TextField}
                        name={'email'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Field
                        fullWidth
                        type={'password'}
                        variant={'outlined'}
                        label={'Password'}
                        value={values.password}
                        component={TextField}
                        name={'password'}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        className={classes.button}
                        variant={'contained'}
                        type={'submit'}
                        color={'primary'}
                        disabled={!isValid}>
                        Login
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </div>
            </div>
          );
        }
      }
    </Formik>
  );
};

Login.propTypes = {

};

const useStyles = makeStyles(
  theme => {
    return {
      container: {
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexGrow: 1,
      },
      card: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 400,
        alignItems: 'center'
      },
      form: {

      },
      button: {
        color: 'white',
        alignSelf: 'center',
      }
    };
  }
);


export default Login;
